const scrollHint = {
  _el: null,
  _container: null,
  _idleTimer: null,
  _idleMs: 30000,
  _bound: false,
  init: function(idleMs) {
    this._idleMs = typeof idleMs === 'number' ? idleMs : this._idleMs;
    this._el = document.querySelector('.scroll-wrapper');
    this._container = document.querySelector('.pages-container');
    if (!this._el || !this._container || this._bound) return;
    this._bound = true;

    // Device hint: flag Android Chrome to allow CSS adjustments
    try {
      const ua = navigator.userAgent.toLowerCase();
      const isAndroidChrome = ua.includes('android') && ua.includes('chrome') && !ua.includes('edg');
      const isIOS = ua.includes('iphone') || ua.includes('ipad') || ua.includes('ipod');
      const isIOSChrome = isIOS && ua.includes('crios');
      if (isAndroidChrome) {
        document.documentElement.classList.add('is-android-chrome');
      }
      if (isIOSChrome) {
        document.documentElement.classList.add('is-ios-chrome');
      }
    } catch(_){}

    const onActivity = () => {
      // Hide immediately on activity
      this._el.classList.add('hidden');
      // Reset idle timer to show after inactivity
      clearTimeout(this._idleTimer);
      this._idleTimer = setTimeout(() => {
        this._el.classList.remove('hidden');
      }, this._idleMs);
    };

    // Bind only to actual scroll interactions (scroll and wheel)
    const optsPassiveFalse = { passive: false };
    const optsPassiveTrue = { passive: true };
    this._container.addEventListener('scroll', onActivity, optsPassiveTrue);
    this._container.addEventListener('wheel', (e)=>{ onActivity(); e.preventDefault(); }, optsPassiveFalse);

    // Initial idle show (ensure visible at start, then schedule hide after first activity)
    clearTimeout(this._idleTimer);
    this._idleTimer = setTimeout(() => {
      this._el.classList.remove('hidden');
    }, this._idleMs);
  }
};

export default scrollHint;